import { fetchWithRetry } from '@tunein/web-utils';
import { handleOpmlError } from '../../errors/OpmlError';
import { camelCase, transformTuneStreams, transformUnwrappedStreams, } from '../../transforms';
import tuneInRequest from '../../tuneInRequest';
import format from 'string-format';
export function tune(config, apiContext, applyReauth, services) {
    const tuneEndpoint = format('{opml}/Tune.ashx', config.domains);
    const proxyEndpoint = format('{local}/proxy/tune', config.domains);
    function load(params) {
        return tuneInRequest({
            method: 'get',
            url: tuneEndpoint,
            params,
        }, apiContext);
    }
    function proxyLoad(params) {
        return tuneInRequest({
            method: 'get',
            url: proxyEndpoint,
            params,
        }, apiContext);
    }
    async function streamUnwrap(url, metadata) {
        const urlObj = new URL(url);
        urlObj.searchParams.set('render', 'json');
        const response = await fetchWithRetry(urlObj.toString(), {
            agent: apiContext.apiHttpsAgent,
        }).then(camelCase);
        return transformUnwrappedStreams(response.streams, metadata);
    }
    const streamUnwrapWithReauth = applyReauth(streamUnwrap);
    async function fetchStreams({ params, requestNowPlaying }) {
        const adswizzListenerId = window.com_adswizz_synchro_getListenerId?.();
        const tuneLoadPromise = load({
            ...params,
            ...(adswizzListenerId && { adswizzListenerId }),
        })
            .then(handleOpmlError)
            .then(response => response.data.body);
        const { id, itemToken } = params;
        let profile;
        if (!requestNowPlaying) {
            return transformTuneStreams({
                streams: await tuneLoadPromise,
                tuneInPlaylistHandler: streamUnwrapWithReauth,
            });
        }
        if (params.id[0] === 'p') {
            profile = await services.profile.getV3(params.id);
        }
        const guideId = profile
            ? profile?.data?.items?.[0]?.children?.[0]?.guideId
            : id;
        const [streams, nowPlayingData] = await Promise.all([
            tuneLoadPromise,
            services.profile.nowPlaying(guideId, { itemToken }),
        ]);
        const boostStreamMetadata = {
            parentGuideId: params.id,
            boostParentGuideId: nowPlayingData?.nowPlaying?.boost?.guideId,
        };
        return {
            ...transformTuneStreams({
                streams,
                tuneInPlaylistHandler: streamUnwrapWithReauth,
                boostStreamMetadata,
            }),
            ...nowPlayingData,
        };
    }
    return {
        load: applyReauth(load),
        proxyLoad: applyReauth(proxyLoad),
        fetchStreams: applyReauth(fetchStreams),
        streamUnwrap: streamUnwrapWithReauth,
    };
}
